class BBBouquetDrop extends HTMLElement {
  connectedCallback() {
    this.renderEstimate();
    this.setupMediaGallery();
    this.estimateTimer = window.setInterval(() => this.renderEstimate(), 60000);
  }

  setupMediaGallery() {
    const stage = this.querySelector('[data-bb-media-stage]');
    const items = Array.from(this.querySelectorAll('[data-bb-media-item]'));
    if (!stage || items.length < 2) return;

    const previous = this.querySelector('[data-bb-media-prev]');
    const next = this.querySelector('[data-bb-media-next]');
    const current = this.querySelector('[data-bb-media-current]');
    let activeIndex = 0;
    let scrollFrame;

    const setActive = (index, shouldScroll = false) => {
      activeIndex = Math.max(0, Math.min(index, items.length - 1));
      if (shouldScroll) {
        items[activeIndex].scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }

      if (current) current.textContent = String(activeIndex + 1);
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === items.length - 1;

      items.forEach((item, index) => {
        item.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
        item.toggleAttribute('inert', index !== activeIndex);
        if (index !== activeIndex) item.querySelector('video')?.pause();
      });
    };

    previous?.addEventListener('click', () => setActive(activeIndex - 1, true));
    next?.addEventListener('click', () => setActive(activeIndex + 1, true));
    stage.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      setActive(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
    });
    stage.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        const closest = items.reduce((best, item, index) => {
          const distance = Math.abs(item.offsetLeft - stage.scrollLeft);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Number.POSITIVE_INFINITY });
        if (closest.index !== activeIndex) setActive(closest.index);
      });
    }, { passive: true });

    setActive(0);
  }

  renderEstimate() {
    const output = this.querySelector('[data-bb-arrival-estimate]');
    if (!output) return;

    const policy = window.BBShipping;
    if (!policy) return;
    const shipDate = policy.nextShipDate();
    const arrivalStart = policy.addCarrierDays(shipDate, policy.rules.carrier_days[0]);
    const arrivalEnd = policy.addCarrierDays(shipDate, policy.rules.carrier_days[1]);
    const format = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });

    output.textContent = `Order today · earliest ship ${format.format(shipDate)} by ${policy.rules.dispatch_by} · estimated arrival ${format.format(arrivalStart)}–${format.format(arrivalEnd)}`;
  }

  disconnectedCallback() {
    window.clearInterval(this.estimateTimer);
  }
}

if (!customElements.get('bb-bouquet-drop')) {
  customElements.define('bb-bouquet-drop', BBBouquetDrop);
}
